import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RouteInterface } from '@interface/route/route.interface';

import { initialRouteState } from './route.initial-state';

export const routeSlice = createSlice({
  name: 'route',
  initialState: initialRouteState,
  reducers: {
    setRoute: (state, { payload: { name, path } }: PayloadAction<RouteInterface>) => {
      state.name = name;
      state.path = path;
    },
  },
});

export const routeActions = routeSlice.actions;
